import { Flex } from "@redotech/arbiter/flex";
import { RedoSpinner } from "@redotech/arbiter/loading/redo-spinner";
import { memo } from "react";

/**
 * The wait a submission page shows in place of its content. Screens hand their
 * pending state to the layout rather than to the continue button, so one
 * spinner in the middle of the page answers "is it working?".
 */
export const PageLoadingSpinner = memo(function PageLoadingSpinner() {
  return (
    <Flex
      align="center"
      data-ui="page-loading"
      grow={1}
      justify="center"
      minH="none"
      w="full"
    >
      <RedoSpinner />
    </Flex>
  );
});
